import { styled } from "theme/default/styled";
import { setFontSize_22px } from "theme/setter/setFontSizeValues/setFontSize_22px";
import { setFontWeight600 } from "theme/setter/setFontWeightValues/setFontWeight600";
import { setColor_rgba_0_0_0_87 } from "theme/setter/setOpacityColorsValues/setColor_rgba_0_0_0_87";

export const SPaymentDetailsPageContentAdditionalInfoHeader = styled.div`
  margin-bottom: 20px;

  ${setFontSize_22px};
  ${setFontWeight600};
  ${setColor_rgba_0_0_0_87};
`;
